var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_c('b-form-checkbox',{attrs:{"value":true,"unchecked-value":false},on:{"change":function($event){return _vm.confirmarNaoAditivarContratacao()}},model:{value:(_vm.naoAditivar),callback:function ($$v) {_vm.naoAditivar=$$v},expression:"naoAditivar"}},[_c('strong',[_vm._v("Essa contratação não será aditivada")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }